import SingleCheckoutBoxAccordion from "./singleCheckoutBoxAccordion.container";
export default SingleCheckoutBoxAccordion;
